import { create } from "zustand";
import { CreditInformationResponse } from "../api/types";

type CreditType = "card" | "aave" | "euler";

interface CreditState {
  creditInfo: Record<CreditType, CreditInformationResponse | null>;
  isLoading: boolean;
  error: string | null;
  // Internal methods for SDK use only
  _setCreditInfo: (type: CreditType, info: CreditInformationResponse) => void;
  _setLoading: (loading: boolean) => void;
  _setError: (error: string | null) => void;
  _reset: () => void;
}

export const useCreditStore = create<CreditState>((set) => ({
  creditInfo: {
    card: null,
    aave: null,
    euler: null,
  },
  isLoading: false,
  error: null,

  // Internal methods for SDK use only (prefixed with _)
  _setCreditInfo: (type, info) =>
    set((state) => ({
      creditInfo: {
        ...state.creditInfo,
        [type]: info,
      },
    })),

  _setLoading: (loading) => set({ isLoading: loading }),
  _setError: (error) => set({ error }),

  _reset: () =>
    set({
      creditInfo: {
        card: null,
        aave: null,
        euler: null,
      },
      isLoading: false,
      error: null,
    }),
}));
